import { render, staticRenderFns } from "./CreateUserBtnDialog.vue?vue&type=template&id=45b83a28&scoped=true"
import script from "./CreateUserBtnDialog.vue?vue&type=script&lang=js"
export * from "./CreateUserBtnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b83a28",
  null
  
)

export default component.exports